module.exports = "https://cdn.thelire.com/ins/resource/faster@3x.a76824bf41b9c86141d7e69b44ff8287.png";